__webpack_require__.p = "https://stage-vdp.qoreai.com/";